import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const containers = Array.from(document.querySelectorAll('.js-card-slider'));

  containers.forEach((container) => {
    const gapDesktop = 24;
    const gapMobile = 16;
    const wrapper = container.querySelector('.js-card-slider-wrapper');
    const prevEl = container.querySelector('.js-card-slider-prev');
    const nextEl = container.querySelector('.js-card-slider-next');

    if (wrapper) {
      // const width = wrapper.clientWidth;
      // container.style.setProperty('--card-slider-width', `${width}px`);
      // container.style.setProperty('--card-slider-gap', `${gap}px`);

      const slider = new Swiper(wrapper, {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: gapDesktop,
        navigation: {
          prevEl,
          nextEl,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.24,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            spaceBetween: gapMobile,
          },
          768: {
            slidesPerView: 2.24,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            spaceBetween: gapMobile,
          },
          992: {
            slidesPerView: 'auto',
            spaceBetween: gapDesktop,
          },
        },
        on: {
          init(swiper) {
            swiper.el.classList.add('has-first-effect');
            swiper.el.classList.add('has-last-effect');

            if (swiper.isBeginning) {
              swiper.el.classList.remove('has-first-effect');
            }
          },
          sliderFirstMove(swiper) {
            swiper.el.classList.add('has-first-effect');
            swiper.el.classList.add('has-last-effect');
          },
          transitionStart(swiper) {
            swiper.el.classList.add('has-first-effect');
            swiper.el.classList.add('has-last-effect');
          },
          transitionEnd(swiper) {
            swiper.el.classList.remove('has-first-effect');

            if (swiper.isEnd) {
              swiper.el.classList.add('has-first-effect');
              swiper.el.classList.remove('has-last-effect');
            }
          },
        },
      });

      slider.init();
    }
  });
});
